import * as React from 'react';
import { BaseForm } from './Base';
import theme from '../../utils/theme';

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export interface CheckboxFieldProps extends InputProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export const CheckboxField = ({
  label,
  id,
  tooltip,
  field,
  type,
  onValueChange,
  defaultValue,
  ...rest
}: CheckboxFieldProps) => (
  <BaseForm label={label} id={id}>
    <label
      className={`${theme.form.field.input} w-100 flex items-center pointer`}
    >
      <input
        id={id}
        type="checkbox"
        onChange={(e) => onValueChange(field, e.target.checked)}
        defaultChecked={defaultValue}
        {...rest}
      />
      <span className="dib ml2">{tooltip}</span>
    </label>
  </BaseForm>
);

export default CheckboxField;
